/* eslint-disable import/prefer-default-export */

import { DeviceNameType, getDevice } from './deviceHelper';

export const toPlainAmount = (amount: string, isInput = false) => {
	const isAppleOS = getDevice() === DeviceNameType.IPHONE;
	let newAmount = amount;
	if (['.', ','].includes(newAmount.toString())) newAmount = '0';
	if (isAppleOS && isInput) {
		return newAmount.replace(/[. ]+/g, '').replace(',', '.');
	}

	return newAmount.replace(/[, ]+/g, '');
};
